import {Component} from '@angular/core';

@Component({
  selector: 'app-export-options-help',
  standalone: true,
  imports: [],
  templateUrl: './export-options-help.component.html',
  styleUrl: './export-options-help.component.scss'
})
export class ExportOptionsHelpComponent {

}
